import { useEffect, useState } from "react";
import { handleGetMyWallets } from "../api-clients/walletAccountsClient";
import {
  AccountBalanceInfo,
  Currency,
} from "@nestcoinco/hyper-api-gateway-api-client";
import useAuth from "./useAuth";

type WalletBalances = Record<Currency, AccountBalanceInfo>;

export default function useWalletBalances() {
  const { isLoggedIn } = useAuth();
  const [walletBalances, setWalletBalances] = useState<WalletBalances>();

  useEffect(() => {
    if (!isLoggedIn) return;

    (async () => {
      const wallets = (await handleGetMyWallets())?.records;
      if (!wallets) return;

      const balances: WalletBalances = wallets.reduce(
        (prevValue, currValue) => ({
          ...prevValue,
          [currValue.asset as Currency]: currValue.balance,
        }),
        {} as WalletBalances,
      );
      setWalletBalances(balances);
    })();
  }, [isLoggedIn]);

  return walletBalances;
}
